import React from 'react';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import { BsArrowsFullscreen } from 'react-icons/bs';

const IframeModal = ({ show, onHide, url, title = 'Content', showSidebar = false }) => {
  const getUrlWithParams = (baseUrl) => {
    try {
      // Nếu URL không bắt đầu bằng http:// hoặc https:// thì bổ sung domain hiện tại
      let fullUrl = baseUrl;
      if (!/^https?:\/\//i.test(baseUrl)) {
        if (!baseUrl.startsWith('/')) fullUrl = '/' + baseUrl;
        fullUrl = window.location.origin + fullUrl;
      }
      const urlObj = new URL(fullUrl);
      if (!showSidebar && !urlObj.searchParams.has('show_sidebar')) {
        urlObj.searchParams.append('show_sidebar', 'false');
      }
      return urlObj.toString();
    } catch (error) {
      console.error('Error processing URL:', error);
      return baseUrl; // Return original URL if there's an error
    }
  };

  const handleExpand = () => {
    const fullUrl = getUrlWithParams(url);
    window.open(fullUrl, '_blank');
  };

  return (
    <Modal
      isOpen={show}
      toggle={onHide}
      size="xl"
      centered
      className="iframe-modal"
      style={{
        maxWidth: '90vw',
        margin: '0 auto'
      }}
    >
      <ModalHeader toggle={onHide} className="position-relative">
        {title}
      </ModalHeader>
      <ModalBody style={{ padding: 0, position: 'relative' }}>
        <iframe
          src={getUrlWithParams(url)}
          style={{
            width: '100%',
            height: '80vh',
            border: 'none'
          }}
          title={title}
        />
        <span
          style={{
            cursor: 'pointer',
            position: 'absolute',
            right: 16,
            bottom: 16,
            background: 'rgba(255,255,255,0.7)',
            borderRadius: '50%',
            padding: 6,
            zIndex: 10
          }}
          onClick={handleExpand}
          title="Open in new tab"
        >
          <BsArrowsFullscreen size={24} />
        </span>
      </ModalBody>
    </Modal>
  );
};

export default IframeModal; 